import { render, staticRenderFns } from "./ReplaceForm.vue?vue&type=template&id=0071894f"
import script from "./ReplaceForm.vue?vue&type=script&lang=js"
export * from "./ReplaceForm.vue?vue&type=script&lang=js"
import style0 from "./ReplaceForm.vue?vue&type=style&index=0&id=0071894f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports